import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        Button
    } = window.wp.components;

    const { Fragment } = window.wp.element;

    registerBlockType('custom-gutenberg/double-image', {
        // built-in attributes
        title: 'Double Image',
        description: 'Double Image One Above Other',
        icon: '',
        category: 'containers',
        example: {},

        // custom attributes
        attributes: {
            image_1: {
                type: 'string',
                default: ''
            }, 
            image_2: {
                type: 'string',
                default: ''
            }
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                image_1, image_2,
                classes,
            } = attributes;

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            // custom functions

            const onSelectImage_1 = (image_1) => {
                setAttributes({ image_1: image_1.sizes.full.url });
            };

            const onSelectImage_2 = (image_2) => {
                setAttributes({ image_2: image_2.sizes.full.url });
            };


            return ([
                <Fragment>
                    <InspectorControls style={ { marginBottom: '40px' } }>
                        <PanelBody title={ 'Settings' }>
                            <MediaUpload 
                            onSelect={(imageObj) => onSelectImage_1(imageObj)}
                            type="image"
                            value={image_1}
                            render={({ open }) => (
                            <div>
                                {image_1 && (
                                    <div>
                                        <figure style={{ margin: 0 }}>
                                            <img src={image_1} style={{ maxWidth: '200px', maxHeight: '150px', objectFit: 'cover' }} />
                                        </figure>
                                             <Button onClick={() => 
                                                setAttributes({ image_1: '' })} 
                                                className="button">
                                                    Remove
                                            </Button>
                                        <br/>
                                    </div>
                                )}
                                <IconButton
                                    onClick={open}
                                    icon="upload"
                                    className="editor-media-placeholder__button is-button is-default is-large"
                                >
                                    Select Image 1 - left
                                </IconButton>
                            </div>
                            )} 
                            />
                        </PanelBody>
                    </InspectorControls>

                     <InspectorControls style={ { marginBottom: '40px' } }>
                        <PanelBody title={ 'Settings' }>
                            <MediaUpload 
                            onSelect={(imageObj) => onSelectImage_2(imageObj)}
                            type="image"
                            value={image_2}
                            render={({ open }) => (
                            <div>
                                {image_2 && (
                                    <div>
                                        <figure style={{ margin: 0 }}>
                                            <img src={image_2} style={{ maxWidth: '200px', maxHeight: '150px', objectFit: 'cover' }} />
                                        </figure>
                                            <Button onClick={() => 
                                                setAttributes({ image_2: '' })} 
                                                className="button">
                                                    Remove
                                            </Button>
                                        <br/>
                                    </div>
                                )}
                                <IconButton
                                    onClick={open}
                                    icon="upload"
                                    className="editor-media-placeholder__button is-button is-default is-large"
                                >
                                    Select Image 2 - right
                                </IconButton>
                            </div>
                                )} 
                            />
                        </PanelBody>
                    </InspectorControls>
                </Fragment>
                ,
                <div className={ "double-image-frame " + (classes ? ' ' + classes : '') }>
                    <span style={ { backgroundImage: `url(${image_1})` } } className='lozad image-1' ></span>
                    <span style={ { backgroundImage: `url(${image_2})` } } className='lozad image-2' ></span>
                </div> 
            ]
            );
        },

        save({ attributes }) {

            const {
                image_1, image_2,
                classes,
            } = attributes;

            return (
                 <div className={ "double-image-frame " + (classes ? ' ' + classes : '') }>
                    <span data-background-image={ image_1 } className='lozad image-1' />
                    <span data-background-image={ image_2 } className='lozad image-2' />
                </div> 
            );
        },
    });
}